import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import { IShapePoint2d } from '@/editor/types/shape';
import { pathToGmtShape } from '../shape';
import { getPathFromEdges } from '../edge';
import { sampleOutlines } from '../wallShape';

/** 闭合路径（可带洞、可带弧）-> 填充几何体 */
export const createShapeGeometry = (path: IShapePoint2d[], holes: IShapePoint2d[][] = []) =>
  new THREE.ShapeGeometry(pathToGmtShape(path, holes));

/**
 * 墙体填充：与 WallModel 一致，先用 sampleOutlines 把弧墙采样成折线，再把各段合成一个几何体。
 * 少了采样这步弧墙会退化成直线。
 */
export const createWallGeometry = (drawShape: IShapePoint2d[][]): THREE.BufferGeometry | undefined => {
  const geometries = sampleOutlines(drawShape)
    .filter((path) => path.length)
    .map((path) => createShapeGeometry(path));

  if (!geometries.length) return undefined;

  return geometries.length > 1 ? mergeGeometries(geometries) : geometries[0];
};

/** 地面：房间、分区都是「核心路径 + 洞」这一种形状 */
export const createFloorGeometry = (
  corePathInfos: Parameters<typeof getPathFromEdges>[0],
  coreHoleInfos: Parameters<typeof getPathFromEdges>[0][] = []
): THREE.BufferGeometry | undefined => {
  if (!corePathInfos.length) return undefined;

  return createShapeGeometry(
    getPathFromEdges(corePathInfos),
    coreHoleInfos.map((holes) => getPathFromEdges(holes))
  );
};
